/**
 * HoverHelmet BUY-1 -> Shopify media synchronizer.
 *
 * IMPORTANT: Only the first bundle/team selector (the Buy 1 card) is mirrored
 * into Shopify's native variant picker. Buy 2 / Buy 3 selectors are intentionally
 * left independent so customers can mix and match different teams.
 */
(() => {
  const normalize = (value) => String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const selectedText = (select) => {
    const option = select.options?.[select.selectedIndex];
    return option ? normalize(option.textContent || option.value) : normalize(select.value);
  };

  const nativePickers = () => Array.from(document.querySelectorAll('product-information variant-picker, variant-picker'));

  const optionMatchesNativeVariant = (select) => {
    const texts = Array.from(select.options).map((o) => normalize(o.textContent || o.value)).filter(Boolean);
    if (!texts.length) return false;
    for (const picker of nativePickers()) {
      const nativeValues = Array.from(picker.querySelectorAll('option, input[type="radio"]')).map((el) => normalize(el.value || el.textContent));
      if (texts.some((t) => nativeValues.includes(t))) return true;
      for (const input of picker.querySelectorAll('input[type="radio"]')) {
        const label = input.id ? picker.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
        if (texts.includes(normalize(label?.textContent))) return true;
      }
    }
    return false;
  };

  const getBuyOneTeamSelect = () => {
    // Bundle cards are rendered outside variant-picker. The first team/specification
    // selector is Buy 1; later matching selectors belong to Buy 2 / Buy 3 and must
    // remain independent for mix-and-match bundles.
    return Array.from(document.querySelectorAll('select'))
      .filter((select) => !select.closest('variant-picker'))
      .find(optionMatchesNativeVariant) || null;
  };

  const syncToShopifyPicker = (sourceSelect) => {
    if (!(sourceSelect instanceof HTMLSelectElement)) return;
    if (sourceSelect !== getBuyOneTeamSelect()) return;

    const wanted = selectedText(sourceSelect);
    if (!wanted) return;

    for (const picker of nativePickers()) {
      for (const select of picker.querySelectorAll('select')) {
        const match = Array.from(select.options).find((option) =>
          normalize(option.textContent) === wanted || normalize(option.value) === wanted
        );
        if (match) {
          if (select.value !== match.value) {
            select.value = match.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }

      for (const input of picker.querySelectorAll('input[type="radio"]')) {
        const label = input.id ? picker.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
        const candidates = [input.value, input.dataset.optionValue, label?.textContent];
        if (candidates.some((candidate) => normalize(candidate) === wanted)) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
    }
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target instanceof HTMLSelectElement) syncToShopifyPicker(target);
  }, true);
})();
